import angular from 'angular';
import _ from 'lodash';
import { EMPLOYER_WORKFLOW_STATUS } from '../../employer/constants/employer-workflow';
import { CANDIDATE_FEEDBACK_STATUSES } from '../../recruiter/constants/feedback';
import { eventTypes } from '../route/workflowService';

export const isFeedbackRequested = (events) => {
    const requestFeedbackEventIndex = _.findIndex(events, { eventType: eventTypes.REQUEST_FEEDBACK });
    const blockRequestFeedbackIndex = _.findIndex(events, { eventType: eventTypes.BLOCK_REQUEST_FEEDBACK });

    return (requestFeedbackEventIndex >= 0 && blockRequestFeedbackIndex < 0)
        || (requestFeedbackEventIndex >= 0 && requestFeedbackEventIndex < blockRequestFeedbackIndex);
};

export const getCurrentEventType = (events) => {
    const feedbackRequested = isFeedbackRequested(events);
    const contactCandidateEventIndex = _.findIndex(events, { eventType: eventTypes.TALENT_EXPERT_CONTACT_CANDIDATE });
    const confirmCandidateEventIndex = _.findIndex(events, { eventType: eventTypes.CONFIRM_RESPONSE });
    const isConfirmResponseEventExist = confirmCandidateEventIndex >= 0;
    const isContactCandidateEventExist = contactCandidateEventIndex >= 0;
    const isConfirmResponse = (!isConfirmResponseEventExist && isContactCandidateEventExist)
        || (confirmCandidateEventIndex > contactCandidateEventIndex);

    if (!feedbackRequested) {
        if (isConfirmResponse) {
            return eventTypes.CONFIRM_RESPONSE;
        }

        return eventTypes.REQUEST_FEEDBACK;
    }

    if (isConfirmResponse) {
        return eventTypes.CONFIRM_RESPONSE;
    }

    return eventTypes.CONTACT_CANDIDATE;
};

export const canRemoveFeedbackRequest = ({ events, feedback } = {}) => {
    const feedbackRequested = isFeedbackRequested(events);
    const candidateReadyForSendForFeedback = _.get(feedback, 'status') === CANDIDATE_FEEDBACK_STATUSES.READY_FOR_SEND;

    return feedbackRequested && candidateReadyForSendForFeedback;
};

export const getWorkflowCounter = () => function (input, name) {
    if (!input) {
        return 0;
    }
    for (let i = 0; i < input.length; i++) {
        if (input[i].status == name) {
            return input[i].count;
        }
    }
    return 0;
};

export const getWorkflowCounterV2 = () => function (input, name) {
    if (!input) {
        return 0;
    }
    for (let i = 0; i < input.length; i++) {
        if (input[i].status == name) {
            return input[i];
        }
    }
    return 0;
};

export const filterByDate = () => function (data, type, status) {
    let ans = 0;
    if (data) {
        for (let i = 0; i < data.length; i++) {
            const item = data[i];
            if (item) {
                const typedItem = item[type];
                if (typedItem) {
                    if (typedItem.current == status) {
                        ans++;
                    }
                }
            }
        }
    }
    return ans;
};

export const getWorkflowCountByType = () => function (data, type, status) {
    let ans = 0;
    if (data) {
        for (let i = 0; i < data.length; i++) {
            const item = data[i];
            if (item) {
                const typedItem = item[type];
                if (typedItem) {
                    if (typedItem.current === status) {
                        ans++;
                    }
                }
            }
        }
    }
    return ans;
};

export const textReplace = () => function (input) {
    input = input || '';
    if (input && input.charAt(0) === '?') {
        input = input.substring(1);
    }
    return input.replace(/\n\?/g, '\n');
};

export const calculatePostedDate = $filter => function (input) {
    const nowDate = new Date();
    const date = new Date(input);
    if (date.toString() === 'Invalid Date') {
        return input;
    }
    const stringDate = $filter('date')(input, 'dd/MM/yy');
    let delta = (nowDate - date) / 1000;

    if (delta < 60) {
        return $filter('translate')('JUST_NOW');
    }
    // calculate (and subtract) Year
    const years = Math.floor(delta / 31536000);
    delta -= years * 31536000;

    if (years) {
        return `${stringDate} (${years} years ago)`;
    }
    // calculate (and subtract) Month
    const months = Math.floor(delta / 2592000);
    delta -= months * 2592000;

    if (months) {
        return `${stringDate} (${months} month ago)`;
    }

    // calculate (and subtract) whole days
    const days = Math.floor(delta / 86400);
    delta -= days * 86400;

    // TODO fix 1 day to add
    if (days) {
        return `${stringDate} (${days} days ago)`;
    }

    // calculate (and subtract) whole hours
    const hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    if (hours) {
        return `${stringDate} (${hours} hours ago)`;
    }

    // calculate (and subtract) whole minutes
    const minutes = Math.floor(delta / 60) % 60;

    if (minutes === 0) {
        return $filter('translate')('JUST_NOW');
    }

    return `${stringDate} (${minutes} minutes ago)`;
};

export const calculatePostedDateFormatted = $filter => function (input) {
    const nowDate = new Date();
    const date = new Date(input);
    if (date.toString() === 'Invalid Date') {
        return input;
    }
    const stringDate = $filter('date')(input, 'dd/MM/yy');
    let delta = (nowDate - date) / 1000;

    if (delta < 60) {
        return $filter('translate')('JUST_NOW');
    }
    // calculate (and subtract) Year
    const years = Math.floor(delta / 31536000);
    delta -= years * 31536000;

    if (years) {
        return `${stringDate}<br /> (${years} years ago)`;
    }
    // calculate (and subtract) Month
    const months = Math.floor(delta / 2592000);
    delta -= months * 2592000;

    if (months) {
        return `${stringDate}<br /> (${months} month ago)`;
    }

    // calculate (and subtract) whole days
    const days = Math.floor(delta / 86400);
    delta -= days * 86400;

    // TODO fix 1 day to add
    if (days) {
        return `${stringDate}<br /> (${days} days ago)`;
    }

    // calculate (and subtract) whole hours
    const hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    if (hours) {
        return `${stringDate}<br /> (${hours} hours ago)`;
    }

    // calculate (and subtract) whole minutes
    const minutes = Math.floor(delta / 60) % 60;

    if (minutes === 0) {
        return $filter('translate')('JUST_NOW');
    }

    return `${stringDate}<br /> (${minutes} minutes ago)`;
};

export const calculateMonthPostedDays = () => function (input) {
    const nowDate = new Date();
    const date = new Date(input);
    let delta = (nowDate - date) / 1000;
    let totalMonths = 0;

    if (delta < 60) {
        return totalMonths; // 0 Months the date is the same
    }
    // calculate (and subtract) Year
    const years = Math.floor(delta / 31536000);
    delta -= years * 31536000;

    if (years) {
        totalMonths += years * 12; // if we have years, we will count total months of the years. for example: 3 years = 3*12 = 36 months
    }
    // calculate (and subtract) Month
    const months = Math.floor(delta / 2592000);
    delta -= months * 2592000;

    if (months) {
        totalMonths += months; // adding total month to the months
    }

    // calculate (and subtract) whole days
    const days = Math.floor(delta / 86400);
    delta -= days * 86400;

    // TODO fix 1 day to add
    if (days) {
        totalMonths += days / 30; // we want to add also how many days in month for example: 23 days so 23/30 will be added to total month
    }
    return totalMonths;
};

export const getFirstActiveJobDate = () => function (status) {
    if (!status) {
        return null;
    }


    let firstActiveDate = status.timestamp;
    const history = status.history || [];
    for (let i = 0; i < history.length; i++) {
        if (history[i].status === 'Active') {
            firstActiveDate = history[i].timestamp;
        }
    }
    return firstActiveDate;
};

export const getJobDateByStatus = () => (positionStatusData, status) => {
    if (!positionStatusData) {
        return null;
    }

    if (positionStatusData.current === status) {
        return positionStatusData.timestamp;
    }

    const historyItem = (positionStatusData.history || []).filter(history => history.status === status);

    return historyItem.timestamp;
};

export const getGradeByCategory = () => function (feedback, category) {
    if (feedback && feedback.grades) {
        for (let i = 0; i < feedback.grades.length; i++) {
            if (feedback.grades[i].category == category) {
                if (feedback.grades[i].grade >= 1) {
                    return 0;
                }
                return 5;
            }
        }
    }
    return 4 + 1;
};

export const getWorkflowEvent = () => function (events, eventType) {
    if (events) {
        return (_.findIndex(events, { eventType }));
    }
    return -1;
};

export const datePosted = () => function (time, period) {
    if (!time || !period) {
        return false;
    }
    let res = false;
    let boundTime = 0;
    const difference = ((new Date().getTime()) - (new Date(time).getTime()));
    const diffInDays = Math.floor(difference / 1000 / 60 / 60 / 24);

    if (period === 'LAST_WEEK') {
        boundTime = 7;
    } else if (period === '2_WEEKS_AGO') {
        boundTime = 14;
    } else if (period === '30_DAYS') {
        boundTime = 30;
    } else if (period === '60_DAYS') {
        boundTime = 60;
    } else if (period === '120_DAYS') {
        boundTime = 120;
    }

    if (period === 'ALL' || diffInDays < boundTime) {
        res = true;
    }
    return res;
};

export const getPositionDatePosted = () => function (status) {
    if (!status) {
        return null;
    }

    let firstActiveDate = status.timestamp;
    for (let i = 0; i < status.history.length; i++) {
        if (status.history[i].status === 'Ready') {
            firstActiveDate = status.history[i].timestamp;
        }
    }
    return firstActiveDate;
};

export const timeLeft = () => function (time) {
    if (!time) {
        return;
    }
    let res = 0;
    if (time < 24) {
        res = Math.round(time);
    } else {
        res = Math.round(time / 24);
    }
    return res;
};

export const getHtmlCode = $sce => function (html) {
    return $sce.trustAsHtml(html);
};

export const getFeedbackStatusText = () => function (feedbacks) {
    let ans = '';
    const acceptedIndex = _.findIndex(feedbacks, (feedback) => {
        if (feedback.status === 'accepted') {
            return false;
        }
    });
    const pendingIndex = _.findIndex(feedbacks, feedback => feedback.status === 'pending');
    if (acceptedIndex > 0 && pendingIndex > 0) {
        ans = 'COMPLETE_RATING';
    } else if (acceptedIndex === 0 && pendingIndex === 0) {
        ans = 'OUR_TE_WILL_PROVIDE_PROSPECTS';
    } else if (acceptedIndex > 0 && pendingIndex === 0) {
        ans = 'THANKS_FOR_RATING_OUR_TE_WILL_PROVIDE_PROSPECTS';
    } else if (pendingIndex > 0 && acceptedIndex === 0) {
        ans = 'START_RATING';
    }
    return ans;
};

export const showFeedbackField = () => function (candidate) {
    let status = false;
    if (candidate.workflow && candidate.workflow.recruiterStatus) {
        if (candidate.workflow.feedback) {
            if (candidate.workflow.feedback.status === 'pending') {
                candidate.feedbackStatus = 'pending';
                status = true;
            } else if (candidate.workflow.feedback.status === 'accepted') {
                candidate.feedbackStatus = 'accepted';
                status = true;
            }
        } else if (candidate.feedback) {
            if (candidate.feedback.status === 'pending') {
                candidate.feedbackStatus = 'pending';
                status = true;
            } else if (candidate.feedback.status === 'accepted') {
                candidate.feedbackStatus = 'accepted';
                status = true;
            }
        } else {
            const requestFeedbackEvent = _.findIndex(candidate.workflow.events, { eventType: eventTypes.REQUEST_FEEDBACK });
            const backToProspects = _.findIndex(candidate.workflow.events, { eventType: eventTypes.BLOCK_REQUEST_FEEDBACK });
            if ((requestFeedbackEvent >= 0 && backToProspects < 0) || (requestFeedbackEvent >= 0 && requestFeedbackEvent < backToProspects)) {
                candidate.feedbackStatus = 'added';
                status = true;
            }
        }
    }
    return status;
};

export const getWorkflowTalenyaJobs = () => function (input, name) {
    if (!input) {
        return 0;
    }
    for (let i = 0; i < input.length; i++) {
        if (input[i].status === name) {
            return input[i].count;
        }
    }
    return 0;
};

export const sumByColumn = () => function (collection, column) {
    let total = 0;

    collection.forEach((item) => {
        total += parseInt(item[column]);
    });

    return total;
};

export const checkManageUsersState = $state => function () {
    return !!($state && $state.current && $state.current.name === 'employer.manageUsers');
};

export const filterEmployerJobsByEmployerRepId = () => function (position, filterValue) {
    if (filterValue === 'ALL') {
        return true;
    }
    return position.employerRepId === filterValue;
};

export const filterEmployerJobsByStatus = () => function (position, selectedFilterValue) {
    if (selectedFilterValue === 'ALL') {
        return true;
    }

    if (selectedFilterValue === 'COMPLETE_JOB_DEFINITION') {
        return !!position.isCompleteJobDefinitionAvailable;
    }
    if (selectedFilterValue === 'START_RATING') {
        return position.feedbackStatus === 'START_RATING';
    }
    if (selectedFilterValue === 'COMPLETE_RATING') {
        return position.feedbackStatus === 'COMPLETE_RATING';
    }

    return false;
};

export const filterEmployerJobsByOpenCloseState = () => function (position, selectedFilterValue) {
    if (selectedFilterValue === 'OPEN') {
        return ['Active', 'Draft', 'Ready'].includes(position.status.current);
    }

    if (selectedFilterValue === 'CLOSED') {
        return ['Cancelled', 'Finished'].includes(position.status.current);
    }

    return false;
};

export const filterEmployerJobsByTitle = () => (jobTitle, selectedFilterValue) => {
    const regExp = new RegExp(selectedFilterValue, 'i');
    const isValid = _.isEmpty(selectedFilterValue) || jobTitle.match(regExp);
    return isValid;
};

export const isContactedCandidate = () => (candidate) => {
    const workflow = _.get(candidate, 'workflow');
    const isEmployerStatusNone = _.get(workflow, 'employerStatus.current') === EMPLOYER_WORKFLOW_STATUS.NONE;
    const isGoodFeedback = _.get(workflow, 'feedback.grades.0.grade') === 1;
    const isContacted = _.get(workflow, 'events', [])
        .find(({ eventType }) => [
            eventTypes.INTERVIEW_CREATED,
            eventTypes.TALENT_EXPERT_CONTACT_CANDIDATE,
            eventTypes.EMPLOYER_CONTACT_CANDIDATE,
            eventTypes.TALENYA_BOT_CONTACT_CANDIDATE,
        ].includes(eventType));

    return isEmployerStatusNone && isGoodFeedback && isContacted;
};

angular
    .module('TALENYA-FE')
    .filter('getWorkflowCounter', getWorkflowCounter)
    .filter('getWorkflowCounterV2', getWorkflowCounterV2)
    .filter('filterByDate', filterByDate)
    .filter('getWorkflowCountByType', getWorkflowCountByType)
    .filter('textReplace', textReplace)
    .filter('calculatePostedDate', calculatePostedDate)
    .filter('calculatePostedDateFormatted', calculatePostedDateFormatted)
    .filter('calculateMonthPostedDays', calculateMonthPostedDays)
    .filter('getFirstActiveJobDate', getFirstActiveJobDate)
    .filter('getJobDateByStatus', getJobDateByStatus)
    .filter('getGradeByCategory', getGradeByCategory)
    .filter('getWorkflowEvent', getWorkflowEvent)
    .filter('isFeedbackRequested', () => isFeedbackRequested)
    .filter('canRemoveFeedbackRequest', () => canRemoveFeedbackRequest)
    .filter('getCurrentEventType', () => getCurrentEventType)
    .filter('datePosted', datePosted)
    .filter('getPositionDatePosted', getPositionDatePosted)
    .filter('timeLeft', timeLeft)
    .filter('getHtmlCode', getHtmlCode)
    .filter('getFeedbackStatusText', getFeedbackStatusText)
    .filter('showFeedbackField', showFeedbackField)
    .filter('getWorkflowTalenyaJobs', getWorkflowTalenyaJobs)
    .filter('sumByColumn', sumByColumn)
    .filter('checkManageUsersState', checkManageUsersState)
    .filter('filterEmployerJobsByOpenCloseState', filterEmployerJobsByOpenCloseState)
    .filter('filterEmployerJobsByTitle', filterEmployerJobsByTitle)
    .filter('filterEmployerJobsByEmployerRepId', filterEmployerJobsByEmployerRepId)
    .filter('filterEmployerJobsByStatus', filterEmployerJobsByStatus)
    .filter('isContactedCandidate', isContactedCandidate);
